import React, { useState, useEffect } from 'react';
import { 
  Layout,  
 
} from 'antd';
import {  
  FacebookOutlined, 
  TwitterOutlined, 
  LinkedinOutlined, 
  YoutubeOutlined, 
} from '@ant-design/icons'; 
import { Container } from 'react-bootstrap'; 
import LogoWhiteIcon from "../../assets/images/logo-white.svg"
import FacebookIcon from "../../assets/images/facebook.svg"
import TwitterIcon from "../../assets/images/twitter.svg"
import InstagramIcon from "../../assets/images/instagram.svg"
import YoutubeIcon from "../../assets/images/youtube.svg" 

import { Link } from 'react-router-dom';



const {  Footer } = Layout; 
 

export default function FooterIndex() {
 
  useEffect(() => {
    // Add custom class to body for global styling
    document.body.classList.add('imergey-body');
    
    return () => {
      document.body.classList.remove('imergey-body');
    };
  }, []);
 

  return (
    <>
     {/* Footer */}
      <footer className="footer-section">
        <Container>
        <div className="footer-header">
          <div className="logo-footer-layout">
            <img src={LogoWhiteIcon} alt="Imergey Logo" className="h-8" />
          </div>
          
          <div className="social-bar-icons">
            <Link href="#" className="footer-social-btn">
              <img src={FacebookIcon} className="" />
            </Link>
            <Link href="#" className="footer-social-btn">
               <img src={TwitterIcon} className="" />
            </Link>
            <Link href="#" className="footer-social-btn">
            <img src={InstagramIcon} className="" />
            </Link>
            <Link href="#" className="footer-social-btn">
            <img src={YoutubeIcon} className="" />
            </Link>
          </div>
          </div>
          <div className="footer-dics">
            <p>
              Imergey, what is it intend to mean? It's probably grammatical incorrect (as it is a custom-built word to create simplicity to business understand our platform) rather you call us IMERGEY.
           Simply defined, it's a platform that will assist business in their daily brand and marketing strategy work. The term imergey was created as one word from three: image, energy and strategy.</p>
          </div>
          
          <div className='footer-bootamline'>
          <div className="trms-text-line">
            <Link href="#">Terms & Conditions</Link>
            <Link href="#">Privacy Policy</Link>
          </div>
          
          <div className="copyright-text">
            <p>Copyright © 2023 Imergey Global All rights All right reserved.</p>
          </div>
          </div>
 
        </Container>
      </footer> 
   

    </>
  );
}